import { Location } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ABP, AuthService, LocalizationWithDefault, RoutesService, TreeNode } from '@abp/ng.core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-http-error',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './http-error.component.html',
    styleUrls: ['./http-error.component.scss'],
    standalone: false
})
export class AppHttpErrorComponent {
  @Input() errorStatus: string | number = '401';
  @Input() destroy$: Subject<void>;

  constructor(
    private location: Location,
    private router: Router,
    private authService: AuthService,
    private routesService: RoutesService
  ) {}

  get errorStatusText(): LocalizationWithDefault | string {
    switch (Number(this.errorStatus)) {
      case 401:
        return { key: 'AbpExceptionHandling::401Message', defaultValue: 'Unauthorized' };
      case 403:
        return { key: 'AbpExceptionHandling::403Message', defaultValue: 'Forbidden' };
      case 404:
        return { key: 'AbpExceptionHandling::404Message', defaultValue: 'Page not found' };
      case 500:
        return { key: 'AbpExceptionHandling::500Message', defaultValue: 'Internal Server Error' };
      default:
        return '';
    }
  }

  get errorDetail(): LocalizationWithDefault | string {
    switch (Number(this.errorStatus)) {
      case 401:
        return {
          key: 'AbpExceptionHandling::DefaultErrorMessage401Detail',
          defaultValue: 'You should sign in to perform this operation.',
        };
      case 403:
        return {
          key: 'AbpExceptionHandling::DefaultErrorMessage403Detail',
          defaultValue: 'You are not allowed to perform this operation!',
        };
      case 404:
        return {
          key: 'AbpExceptionHandling::DefaultErrorMessage404Detail',
          defaultValue: 'The resource requested could not found on the server!',
        };
      case 500:
        return {
          key: 'AbpExceptionHandling::DefaultErrorMessage',
          defaultValue: 'An error has occurred!',
        };
      default:
        return '';
    }
  }

  goBack(): void {
    this.destroy$?.next();
    this.location.back();
  }

  logout(): void {
    this.destroy$?.next();
    this.authService.logout().subscribe();
  }
}
